import React, { memo, useMemo } from "react"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import { makeStyles, withStyles } from "@material-ui/core/styles"
import globalUseStyles from "@/globalUseStyles"
import Typography from "@material-ui/core/Typography"
import clsx from "clsx"
import ProjectDashboardContentBody from "@/components/project-dashboard/ProjectDashboardContentBody"
import modalStatusHandler from "@/redux/actions/modalAction"
import { useDispatch, useSelector } from "react-redux"
import { resetActivateProcess } from "@/redux/actions/activateProjectProcessAction"
import { Breadcrumbs, FormControl, IconButton, Input, InputLabel, MenuItem, Select, TextField } from "@material-ui/core"
import {Link} from 'react-router-dom'
import { Filter1Outlined, Filter2Outlined, MenuOutlined, SearchOutlined } from "@material-ui/icons"
import ProjectActions from "./ProjectActions"
import PageHeader from "./shared-component/page-header"
import { getUserTopRole } from "@/utils"

const useStyles = makeStyles((theme) => ({
    addProjectButton: {
        marginBottom: theme.spacing(4),
    },
    contentHeader: {
        display: "flex",
        justifyContent: "space-between",
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderColor: theme.palette.sparcaLightGrey.main,
        padding: theme.spacing(4),
        alignItems: "center"
    },
    contentHeaderElement: {
        // margin: theme.spacing(4),
    },
    contentHeaderButton: {
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
    ProjectDashboardContentBodyWrapper: {
        padding: theme.spacing(4),
        position: "relative",
        width: "100%",
        height: "100%",
    },
    formControl: {
        width: '240px',
        height: "40px"
    },
    formItem: {
        height: "32px",
        '& .MuiFormLabel-root[data-shrink=false]': {
            top: 4
        }
    }

}))




const ProjectDashboardContent = ({ drawerOpen, setDrawerOpen }) => {
    const classes = useStyles()
    const globalClasses = globalUseStyles()
    const dispatch = useDispatch()

    const handleAddProject = () => {
        dispatch(
            modalStatusHandler({
                modalProjectId: null,
                currentStep: 1,
                modalShow: true,
            })
        )
        dispatch(resetActivateProcess)
    }

    const userRoleData = useSelector((state) => state.userRoleReducer)
    const userData = useSelector((state) => state.userReducer)
    const { user } = userData
    const { userRolesArray } = userRoleData
    const loginUserRoles = userRolesArray.find((userRoleItem) => userRoleItem.userId === user.userId).userRoles
    const topRole = useMemo(() => getUserTopRole(loginUserRoles), userRolesArray)
    // detect if role is project manager or account holder, if it is, show add project button
    const managerRole = topRole.roleName === process.env.PROJECT_MANAGER
    const accountHolderRole = topRole.roleName === process.env.ACCOUNT_HOLDER

    const Links = () => (
        <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to={"/"} className={globalClasses.link}>
                Home
            </Link>
            <Typography color="textPrimary">Project Dashboard</Typography>
        </Breadcrumbs>
    )
    return (
        <>
            <PageHeader pageTitle={"My Projects"} links={<Links />} />
            <ProjectActions />
            <Box component="div" className={classes.ProjectDashboardContentBodyWrapper} fontSize="fontSize" fontFamily="fontFamily">
                <ProjectDashboardContentBody />
            </Box>
        </>
    )
}

export default ProjectDashboardContent
